module.exports = ".Thanks{max-width:480px;margin:auto}\n"